export default __webpack_public_path__ + "static/media/diamond-color-5@2x.0d2e198d.png";